import { CommandList } from "./CommandList";
import { Platform, Platforms } from "./PlatformCommandInteraction";

export class AppCommands
{
  selectedProfile:string = "default";
  selectedPlatform:Platform  = Platforms.Windows;
  profileCommandLists:CommandList[] = [];

  getCommand( name:string )
  {
    let list = this.profileCommandLists.find( p => p.profile == this.selectedProfile );

    let entry = list.commandEntries.find( e => e.name == name );

    if ( entry )
    {
      return entry;
    }

    let processedLists = [];

    let hasParentProfile = ! ( list.parentProfile == null ||  list.parentProfile == undefined || list.parentProfile == "" );

    while ( hasParentProfile )
    {
      let parentList = this.profileCommandLists.find( p => p.profile == list.parentProfile );

      if ( ! parentList )
      {
        return null;
      }

      let entry = parentList.commandEntries.find( e => e.name == name );

      if ( entry )
      {
        return entry;
      }

      if ( processedLists.indexOf( list.profile ) !== -1 )
      {
        return null;
      }

      processedLists.push( list.profile );
      
      list = parentList;

      

      hasParentProfile = ! ( list.parentProfile == null ||  list.parentProfile == undefined || list.parentProfile == "" );
    }
    
    return null;
    
  }
}